module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-z5-547af9d253db3c6232b0f7d81977783c.svg";